/* Bootstrap  */
//import "bootstrap";
import { Modal, Tab, Collapse, Tooltip } from 'bootstrap'
import { v4 as uuid } from "uuid";
import html2pdf from "html2pdf.js"

/* Custom SCSS */
import "./index.scss";

/* Fancybox */
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import XHR from '@uppy/xhr-upload';
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import Swiper, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const input_loader = '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>';




jQuery(document).ready( function($) { 

    Fancybox.bind('[data-fancybox]');

    $('body').on('click', '#btn_notifica_esito', function() {
        jQuery.ajax({
            type: "POST",
            context: this,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'invia_notifica_esito',
                project_id: $(this).data('progetto'),
                'languagecode': ajax_auth_object.languagecode
            },
            success: function (response) {
                $(this).prop("disabled", true);
                $(this).html('Notification sent')
            }
        });
    })

    $('body').on('click', '.btn-admit', function() {
        jQuery.ajax({
            type: "POST",
            url: ajax_auth_object.ajaxurl,
            context: this,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'admit_candidatura',
                project_id: $(this).data('id'),
                stato_candidatura: $(this).data('stato'),
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('#spinner_wrapper').addClass('d-none')    
                if($(this).data('stato')=='ammesso') {
                    $(this).closest('.candidatura_slider').find('.stato_badge').html('<span class="px-3 d-block badge bg-success text-light">Admitted</span>')
                    $('#progetto_giuria_'+$(this).data('id')).find('.stato').html('<span class="d-block badge bg-success text-light">Admitted</span>')
                } 
                if($(this).data('stato')=='rifiutato') {
                    $(this).closest('.candidatura_slider').find('.stato_badge').html('<span class="px-3 d-block badge bg-danger text-light">Rejected</span>')
                    $('#progetto_giuria_'+$(this).data('id')).find('.stato').html('<span class="d-block badge bg-danger text-light">Rejected</span>')
                } 
            }
        });
    })

    function loadCandidatura(project_id) {
        jQuery.ajax({
            type: "POST",
            url: ajax_auth_object.ajaxurl,
            context: this,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'load_candidatura',
                project_id: project_id,
                'languagecode': ajax_auth_object.languagecode,
                current_user_role: ajax_auth_object.current_user_role
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('#candidatura_'+project_id).html(data)
                $('#spinner_wrapper').addClass('d-none')    
            }
        });
    }

    const candidature_slider = new Swiper('.candidature_slider', {
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        simulateTouch: false,
        modules: [Navigation]
    });
    candidature_slider.on('slideChange', function(swiper) {

        $('.candidature_slider .swiper-slide').html('')

        const activeIndex = this.activeIndex;
        const activeSlide = this.slides[activeIndex];
        if(activeSlide) {
            var attrValue = activeSlide.getAttribute('data-id');
            loadCandidatura(attrValue)
        }


    });


    if($('#candidatureModal').length) {
        const candidatureModal = new Modal('#candidatureModal', {
            backdrop: 'static',
            keyboard: false
        })
        $('.progetto_giuria').click(function() {
            var current_index = $(this).data('index')
            var current_id = $(this).data('id')
            candidature_slider.slideTo(current_index)
            candidatureModal.show();
            loadCandidatura(current_id)
        })
    }

    if($('.forme_sinistra').length) {
        var tlSfondoSx = gsap.timeline()
        if($( window ).width()<990) {
            tlSfondoSx.to(".forme_sinistra", {
                opacity: 0,
                y: "+=250%",
                scrollTrigger: {
                    trigger: "body",
                    start: "top top", 
                    end: "bottom bottom",
                    scrub: 1
                }
            });    
        } else {
            tlSfondoSx.to(".forme_sinistra", {
                opacity: 0,
                y: "+=50%",
                scaleX:1.4, 
                scaleY:1.4,
                scrollTrigger: {
                    trigger: "body",
                    start: "top top", 
                    end: "bottom bottom",
                    scrub: 1
                }
            });    
        }
    
    }

    if($('.forme_destra').length) {
        var tlSfondoDx = gsap.timeline()
        tlSfondoDx.to(".forme_destra", {
            opacity: 0,
            y: "-=30%",
            scaleX:1.2, 
            scaleY:1.2,
            scrollTrigger: {
                trigger: "body",
                start: "top top", 
                end: "bottom bottom",
                scrub: 1
            }
        });
    }

    if($('.intro_txt').length) {
        var tlSfondoIntro = gsap.timeline()
        tlSfondoIntro.to(".intro_txt", {
            backgroundPosition: '-14vw 35vh, 75vw 50vh , 23vw 138vh',
            scrollTrigger: {
                trigger: ".intro_txt",
                start: "top bottom", 
                end: "bottom top",
                scrub: 1
            }
        });
    }

    $('body').on('keyup', '.conta_caratteri_input', function() {
        var conta = $(this).val().length
        var max_char = $(this).attr('maxlength')
        $(this).prev('label').find('.conta').html(max_char-conta)
    })

    $('body').on('click', '.print_pdf', function(e) {
        e.preventDefault()
        jQuery.ajax({
            type: "POST",
            url: ajax_auth_object.ajaxurl,
            context: this,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'load_form_project_pdf',
                project_id: $(this).data('id'),
                tipo: 'pdf',
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('body').find('#pdf_wrapper').empty()
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('#pdf_wrapper').html(data)
                $('#spinner_wrapper').addClass('d-none')
                const opt = {
                    margin:       [4, 1.5, 4, 1.5],
                    filename:     $(this).data('id')+'_'+$(this).data('nome')+'.pdf',
                    image:        { type: 'jpeg', quality: 0.98 },
                    html2canvas:  { scale: 2, useCORS: true },
                    jsPDF:        { unit: 'cm', format: 'a4' },
                    pagebreak: {mode: ['avoid-all']}
                };
                const element = document.getElementById('pdf_wrapper'); 

                html2pdf().set(opt).from(element).toPdf().get('pdf').then(function (pdf) {
                    var totalPages = pdf.internal.getNumberOfPages();
                    
        
                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.addImage(ajax_auth_object.baseurl+'/images/HeaderPdf.jpg', "JPG", 1.5, 1.5, 18, 1.4); 
                        pdf.setFontSize(9)   
                        pdf.text('ADI – Associazione per il Disegno Industriale', 10.5, 27, {align:'center'})    
                        pdf.text('Via Bramante 29, 20154 Milan, Italy', 10.5, 27.5, {align:'center'})    
                        pdf.text('Headquarters: ADI Design Musem, piazza Compasso d’Oro, 20154 Milan, Italy', 10.5, 28, {align:'center'})    
                        pdf.text('compassodorointernational@adi-design.org', 10.5, 28.5, {align:'center'})    
                    }

                }).save();


            }
        });



    })

    $('#upload').on('click', function() {

        var file_data = $('#sortpicture').prop('files')[0];   
        console.log(file_data)
        var form_data = new FormData();                  
        form_data.append('file', file_data);
        form_data.append('action', 'upload_images2');

        $.ajax({

            type: "POST",
            url: ajax_auth_object.ajaxurl,
            contentType: 'multipart/form-data',
            processData: false,

            data: form_data,
            success: function(php_script_response){
                console.log(php_script_response); // <-- display response from the PHP script, if any
            },
            error: function(error) {
                console.log(error)
            }
        });
    });

	var file_frame; 
	$( 'body' ).on('click', '#btn-upload-images', function( event ) {
		event.preventDefault();

		// if the file_frame has already been created, just reuse it
		if ( file_frame ) {
			file_frame.open();
			return;
		}

		file_frame = wp.media.frames.file_frame = wp.media({
			title: 'Titolo uploader',
			button: {
				text: 'Inserisci foto',
			},

			multiple: true // set this to true for multiple file selection
		});

		file_frame.on( 'select', function() {
			var attachment = file_frame.state().get('selection').toJSON();
			console.log(attachment)
			var html = ''
            for (let i = 0; i < attachment.length; i++) { 
                html += '<div class="image_item"><div class="row">'
                html += '<div class="col-2"><img src="'+attachment[i].sizes.thumbnail.url+'" width="'+attachment[i].sizes.thumbnail.width+'" height="'+attachment[i].sizes.thumbnail.height+'" /></div>'
                html += '<div class="col-4">'+attachment[i].title+'</div>'
                html += '<div class="col-2">Copertina</div>'
                html += '<div class="col-2">Pubblicabile</div>'
                html += '<div class="col-2">X</div>'
                html += '</div></div>'
            }
            $('.immagini').find('.items_wrapper').append(html)

            jQuery.ajax({
                type: "POST",
                context: this,
                url: ajax_auth_object.ajaxurl,
                data: {
                    'security': $('input[name="security"]').val(),
                    action: 'upload_images',
                    name: 'immagini',
                    value: attachment,
                    project_id: $('.custom_form').find('input[name="project_id"]').val(),
                    'languagecode': ajax_auth_object.languagecode
                },
                beforeSend: function() {
                    $('#spinner_wrapper').removeClass('d-none')
                },
                success: function (data) {
                    $('#spinner_wrapper').addClass('d-none')
                }
            });

		});

		file_frame.open();
	});


    $('body').on('click', '.new_progetto', function() {

        $('.actions_btn').addClass('d-none')

        jQuery.ajax({
            type: "POST",
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'load_form_project',
                user: $(this).data('user'),
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('body').find('.singolo_progetto').empty()
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {

                $('.next_step').removeClass('d-none')

                const wrapper_id = uuid()

                var html = '<div id="'+wrapper_id+'" class="progetto_tease mb-2 status_publish"></div>'
                $('.progetti').append(html);

                $('#'+wrapper_id).html(data)
                var project_id = $('#'+wrapper_id).find('input[name="project_id"]').val()
                $('#'+wrapper_id).attr('id', 'progetto_tease_'+project_id)
                $('#spinner_wrapper').addClass('d-none')


                instanzia_uppy_images(project_id)
                instanzia_uppy_pdf(project_id)
                verifica_required()
                document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(tooltipNode => {
                    new Tooltip(tooltipNode);
                });
                $('.conta_caratteri_input').each(function() {
                    var conta = $(this).val().length
                    var max_char = $(this).attr('maxlength')
                    $(this).prev('label').find('.conta').html(max_char-conta)    
                })
            }
        });
    })

    $('.open_new_aggiunta').click(function() {
        $(this).next('.form_aggiunta').removeClass('d-none')
    })

    $('body').on('click', '.btn-close-progetto', function(e) {
        e.preventDefault()

        jQuery.ajax({
            type: "POST",
            url: ajax_auth_object.ajaxurl,
            context: this,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'load_progetti',
                current_user_id: ajax_auth_object.current_user_id,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('.step_content').html(data)
                $('#spinner_wrapper').addClass('d-none')
            }
        });

    })

    $('body').on('click', '.edit_progetto', function() {

        $('.actions_btn').addClass('d-none')

        const tipo = $(this).data('tipo')

        jQuery.ajax({
            type: "POST",
            url: ajax_auth_object.ajaxurl,
            context: this,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'load_form_project_edit',
                project_id: $(this).data('id'),
                tipo: 'screen',
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('body').find('.singolo_progetto').empty()
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {

                $(this).closest('.progetto_tease').empty()

                $('#progetto_tease_'+$(this).data('id')).html(data)
                $('#spinner_wrapper').addClass('d-none')

                if(tipo=='show') {
                    $('#progetto_tease_'+$(this).data('id')).find('input, textarea, select, button').prop('disabled', true)
                    $('#progetto_tease_'+$(this).data('id')).find('.btn-close-progetto').prop('disabled', false)
                } else {
                    var conta_immagini = $('.immagini').find('.items_wrapper .immagine_item').length
                    instanzia_uppy_images($(this).data('id'), (10-conta_immagini))
                    instanzia_uppy_pdf($(this).data('id'))    
                }
                verifica_required()
                document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(tooltipNode => {
                    new Tooltip(tooltipNode);
                });

                $('.conta_caratteri_input').each(function() {
                    var conta = $(this).val().length
                    var max_char = $(this).attr('maxlength')
                    $(this).prev('label').find('.conta').html(max_char-conta)    
                })
            }
        });
    })


    function instanzia_uppy_images(pid, maxNumberOfFiles=10) {

        if($('#uppy-dashboard').length==0) return true
        const uppy = new Uppy({
            autoProceed: true,
            meta: {
                project_id: pid,
                tipo: 'immagini'
            },
            restrictions: {
                allowedFileTypes: ['.jpg', '.jpeg'],
                maxNumberOfFiles: maxNumberOfFiles,
                maxFileSize: 10000000
            }});
        uppy.use(Dashboard, { 
            inline: false, 
            trigger: '#btn-open-uploader', 
            target: '#uppy-dashboard',
            closeAfterFinish: true,
            proudlyDisplayPoweredByUppy: false,
            hideProgressAfterFinish: true,
        })
        uppy.use(XHR, { 
            endpoint: ajax_auth_object.baseurl+'/includes/ajaxupload.php',
            fieldName: 'file[]',
            formData: true,
            responseType: 'json',
            bundle: true,
            getResponseData: (responseText, response) => {
                return {
                    url: 'json.url'
                };
            }
        });

        uppy.on('upload-error', (file, error, response) => {
            console.error('Error with file:', file.name);
            console.error('Error message:', error);
            console.error('Response:', response);
        });
        uppy.on('complete', (result) => {
            load_project_images(pid)
        });
    }

    function instanzia_uppy_pdf(pid) {
        const uppy = new Uppy({
            autoProceed: true,
            meta: {
                project_id: pid,
                tipo: 'pdf'
            },
            restrictions: {
                allowedFileTypes: ['.pdf'],
                maxNumberOfFiles: 5,
                maxFileSize: 5000000,
            }});
        uppy.use(Dashboard, { 
            inline: false, 
            trigger: '#btn-open-uploader-pdf', 
            target: '#uppy-dashboard-pdf',
            closeAfterFinish: true,
            proudlyDisplayPoweredByUppy: false,
            hideProgressAfterFinish: true,
        })
        uppy.use(XHR, { 
            endpoint: ajax_auth_object.baseurl+'/includes/ajaxupload.php',
            fieldName: 'file[]',
            formData: true,
            responseType: 'json',
            bundle: true,
            getResponseData: (responseText, response) => {
                return {
                    url: 'json.url'
                };
            }
        });

        uppy.on('upload-error', (file, error, response) => {
            console.error('Error with file:', file.name);
            console.error('Error message:', error);
            console.error('Response:', response);
        });
        uppy.on('complete', (result) => {
            load_project_pdf(pid)
        });
    }

    $('body').on('click', '.delete-project', function() {
        jQuery.ajax({
            type: "POST",
            context: this,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'delete_project',
                id: $(this).data('id'),
                current_user_id: ajax_auth_object.current_user_id,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('.step_content').html(data)
                $('#spinner_wrapper').addClass('d-none')
            }
        });
    })

    $('body').on('click', '.immagini .delete-image', function(e) {
        e.preventDefault()
        var project_id = $(this).closest('.immagini').nextAll('input[name="project_id"]').val()
        jQuery.ajax({
            type: "POST",
            context: this,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'delete_image',
                row: $(this).data('id'),
                img_id: $(this).data('img-id'),
                project_id: project_id,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (response) {
                aggiorna_completamento(response, $(this))
                load_project_images(project_id)
            }
        });
    })

    $('body').on('click', '.aggiungi_video', function(e) {
        e.preventDefault()
        var project_id = $(this).closest('.custom_form').find('input[name="project_id"]').val()
        jQuery.ajax({
            type: "POST",
            context: this,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'add_row_repeater',
                project_id: project_id,
                name: $(this).data('name'),
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                load_project_video(project_id)
            }
        });
    })
    $('body').on('click', '.video .delete-video', function(e) {
        e.preventDefault()
        var project_id = $(this).closest('.video').nextAll('input[name="project_id"]').val()
        jQuery.ajax({
            type: "POST",
            context: this,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'delete_video',
                row: $(this).data('id'),
                project_id: project_id,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                load_project_video(project_id)
            }
        });
    })

    $('body').on('change', '#couponSwitch', function() {
        var input_coupon = $(this).closest('.coupons').find('input[name="codice_sconto_index"]')
        $(this).closest('.coupons').find('.coupon_response').html('')
        if($(this).is(':checked'))
            input_coupon.removeClass('d-none')
        else
            input_coupon.addClass('d-none')            
    })

    $('body').on('click', '.file_pdf .delete-file', function(e) {
        e.preventDefault()
        var project_id = $(this).closest('.file_pdf').nextAll('input[name="project_id"]').val()
        jQuery.ajax({
            type: "POST",
            context: this,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'delete_pdf',
                row: $(this).data('id'),
                project_id: project_id,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                load_project_pdf(project_id)
            }
        });
    })

    function load_project_images(project_id) {
        jQuery.ajax({
            type: "POST",
            context: this,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'get_project_images',
                project_id: project_id,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('.immagini').find('.items_wrapper').html(data)
                get_project_data(project_id)

                var conta_immagini = $('.immagini').find('.items_wrapper .immagine_item').length

                if(conta_immagini<10) {
                    $('#uppy_wrapper_wrapper').html('<div id="uppy_wrapper" class="col-lg-3"><button id="btn-open-uploader" class="btn btn-light w-100" type="button">+ Aggiungi file</button><div id="uppy-dashboard"></div></div><div class="col-lg-9 d-flex align-items-center">Utilizza Ctrl o Shift per aggiungere più file contemporaneamente</div>')
                    instanzia_uppy_images(project_id, (10-conta_immagini))
                } else {
                    $('#uppy_wrapper_wrapper').html('<div class="col-12 text-center">Non puoi aggiungere altre immagini</div>')
                }
                $('#spinner_wrapper').addClass('d-none')
            }
        });
    }

    function get_project_data(project_id) {
        jQuery.ajax({
            type: "POST",
            context: this,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'get_project_data',
                project_id: project_id,
                'languagecode': ajax_auth_object.languagecode
            },
            success: function (response) {
                aggiorna_completamento(response, $('#form_progetto'))
            }
        });
    }

    function load_project_pdf(project_id) {
        jQuery.ajax({
            type: "POST",
            context: this,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'get_project_pdf',
                project_id: project_id,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('.file_pdf').find('.items_wrapper').html(data)
                $('#spinner_wrapper').addClass('d-none')
            }
        });
    }

    function load_project_video(project_id) {
        jQuery.ajax({
            type: "POST",
            context: this,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'get_project_video',
                project_id: project_id,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('.video').find('.items_wrapper').html(data)
                $('#spinner_wrapper').addClass('d-none')
            }
        });
    }

    function update_field(action, element) {
        var name = element.attr('name')
        jQuery.ajax({
            type: "POST",
            context: element,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: action,
                name: name,
                value: element.val(),
                project_id: element.closest('.custom_form').find('input[name="project_id"]').val(),
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $(this).closest('.wpcf7-form-control-wrap').append(input_loader)
            },
            success: function (response) {
                if(element.attr('name')=='prodotto_fisico') {
                    if(element.val()=='si') {
                        $('#riga_misure').removeClass('d-none')
                    } else {
                        $('#riga_misure').addClass('d-none')
                    }
                }
                if(element.attr('name')=='imm_copertina') {
                    var pubblicabile = $(this).closest('.immagine_item').find('.img_pubblicabile')
                    $(this).closest('.items_wrapper').find('.img_pubblicabile').prop( "disabled", false )
                    pubblicabile.prop( "disabled", true );
                    if(!pubblicabile.is(':checked')) {
                        pubblicabile.prop( "checked", true ).change();
                    }
                }
                if(element.attr('name')=='post_title') {
                    element.closest('.progetto_tease').find('.project_title').html(element.val())
                    element.closest('.progetto_tease').find('.print_pdf').attr('data-nome', element.val())

                    
                }

                $(this).closest('.progetto_tease').find()
                $(this).closest('.wpcf7-form-control-wrap').find('.lds-ellipsis').remove()

                aggiorna_completamento(response, $(this))
            }
        });
    }

    function aggiorna_completamento(response, element) {
        if(response.success && response.data.completamento) {
            element.closest('.progetto_tease').find('.barra_colore').css('width', response.data.completamento+'%')
            element.closest('.progetto_tease').find('.perc_completamento').text(response.data.completamento)     
            if (response.data.completamento < 41)
                var colore = 'rgb(242,71,38)'
            else if (response.data.completamento < 100 && response.data.completamento > 40)
                var colore = 'rgb(250,199,17)'
            else if (response.data.completamento == 100)
                var colore = 'rgb(143,209,78)'
            element.closest('.progetto_tease').find('.barra_colore').css('background-color', colore)
        }

        verifica_required()

    }



    function update_field_acf_true_false(action, element) {
        var name = element.attr('name')
        jQuery.ajax({
            type: "POST",
            context: element,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: action,
                name: name,
                value: element.is(':checked') ? 1 : 0,
                project_id: element.closest('.custom_form').find('input[name="project_id"]').val(),
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('#spinner_wrapper').addClass('d-none')
            }
        });
    }

    function update_field_row(action, element, row) {
        var repeater_name = element.attr('repeater_name')
        var item_name = element.attr('item_name')
        jQuery.ajax({
            type: "POST",
            context: element,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: action,
                repeater_name: repeater_name,
                item_name: item_name,
                row: row,
                value: element.is(':checked') ? 1 : 0,
                project_id: element.closest('.custom_form').find('input[name="project_id"]').val(),
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('#spinner_wrapper').addClass('d-none')
            }
        });
    }

    function update_field_row2(action, element, row) {
        var repeater_name = element.attr('repeater_name')
        var item_name = element.attr('item_name')
        jQuery.ajax({
            type: "POST",
            context: element,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: action,
                repeater_name: repeater_name,
                item_name: item_name,
                row: row,
                value: element.val(),
                project_id: element.closest('.custom_form').find('input[name="project_id"]').val(),
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('#spinner_wrapper').addClass('d-none')
            }
        });
    }

    function update_acf_relation(action, element, project_id) {
        var name = element.attr('name')
        jQuery.ajax({
            type: "POST",
            context: element,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: action,
                name: name,
                value: element.val(),
                project_id: project_id,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (response) {
                $('#spinner_wrapper').addClass('d-none')
                aggiorna_completamento(response, $('#form_progetto'))
            }
        });
    }

    $('body').on('change', '.custom_form .update_acf', function() {
        update_field('update_field_acf', $(this))
    })

    $('body').on('change', '.custom_form .update_vote', function() {
        var pid = $(this).closest('.custom_form').find('input[name="project_id"]').val()
        jQuery.ajax({
            type: "POST",
            context: $(this),
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'update_vote',
                value: $(this).val(),
                project_id: pid,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('.stato_candidatura').html('<span class="d-block badge bg-success text-light">Voted: '+data.data+'</span>')
                $('#progetto_giuria_'+pid).find('.stato').html('<span class="d-block badge bg-success text-light">Voted: '+data.data+'</span>')
                $('#spinner_wrapper').addClass('d-none')
            }
        });
    })

    $('body').on('change', '.custom_form .update_note', function() {
        var pid = $(this).closest('.custom_form').find('input[name="project_id"]').val()
        jQuery.ajax({
            type: "POST",
            context: $(this),
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'update_note',
                value: $(this).val(),
                project_id: pid,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                $('#spinner_wrapper').addClass('d-none')
            }
        });
    })

    $('body').on('change', '.custom_form .update_acf_sconto_index', function() {
        jQuery.ajax({
            type: "POST",
            context: $(this),
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'check_coupon',
                value: $(this).val(),
                project_id: $(this).closest('.custom_form').find('input[name="project_id"]').val(),
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                if(data.data!=='OK') {
                    $(this).closest('.coupons').find('#couponSwitch').prop('checked', false)
                    $(this).addClass('d-none')
                    $(this).closest('.coupons').find('.coupon_response').html(data.data)
                    $(this).closest('.coupons').find('.update_acf_sconto_index').val('')
                } else {
                    $(this).addClass('disabled')
                    $('#couponSwitch').prop("disabled", true);
                }
                $('#spinner_wrapper').addClass('d-none')
            }
        });
    })
    $('body').on('change', '.custom_form .update_acf_true_false', function() {
        update_field_acf_true_false('update_field_acf', $(this))
    })
    $('body').on('change', '.custom_form .update_post', function() {
        update_field('update_post', $(this))
    })
    $('body').on('change', '.custom_form .update_post_thumbnail', function() {
        update_field('imposta_post_thumbnail', $(this))
    })
    $('body').on('change', '.custom_form .update_radio', function() {
        update_field('update_radio', $(this))
    })
    $('body').on('change', '.custom_form .update_term', function() {
        update_field('update_term', $(this))
    })
    $('body').on('change', '.img_pubblicabile', function() {
        var row = $(this).data('row')
        update_field_row('update_field_acf_row', $(this), row)
    })
    $('body').on('change', '.update_field_acf_row', function() {
        var row = $(this).data('row')
        update_field_row2('update_field_acf_row', $(this), row)
    })
    
    $('body').on('submit', '#form_progetto2', function(e) {
        e.preventDefault();

        var formData = new FormData(document.getElementById('form_progetto2'));

        $.ajax({
            url: ajax_auth_object.ajaxurl, 
            type: 'POST',
            data: {
                'form_data': formData,
                'action': 'upload_images'
            },
            // processData: false,
            // contentType: false,
            success: function(response) {
                // Gestisci la risposta del server
                console.log(response);
            },
            error: function(xhr, status, error) {
                console.error('Error:', error);
                console.error('XHR:', xhr);
                console.error('Status:', status);
              }
        });
    });


    const myModalDe = document.getElementById('addDesignerModal')
    if(myModalDe) {
        myModalDe.addEventListener('show.bs.modal', event => {
            openModalAnagrafiche(event, '#addDesignerModal', 'designers')
            var radios = $('#addDesignerModal').find('input[name="tipo_anagrafica"]')
            radios.each(function() {
                $(this).next('.wpcf7-list-item-label').html( ajax_auth_object.translations[$(this).val()])
            })
        })

        $('#selezione_designers_esistente').on('change', function() {
            var html = ''
            html += '<div class="row pt-1 elemento_designer">'
            html += '<div class="col-8 col-lg-10"><div class="wrapper d-flex align-items-center">'+$(this).find("option:selected" ).text()+'</div></div>'
            html += '<div class="col-4 col-lg-2"><button type="button" data-id="'+$(this).val()+'" data-tipo="designer" class="btn-rimuovi-anagrafica w-100 btn btn-outline-dark">'+ajax_auth_object.translations.rimuovi+'</button></div></div>'
            $('.selezione_designers').append(html)
            $('#addDesignerModal').modal('hide')

            checkElementiDesignerLength()

            update_acf_relation('update_field_relation', $(this), $(this).attr('data-id-project'))
        })
    }
    const myModalAz = document.getElementById('addAziendaModal')
    if(myModalAz) {
        myModalAz.addEventListener('show.bs.modal', event => {
            openModalAnagrafiche(event, '#addAziendaModal', 'aziende')
        })
        $('#selezione_aziende_esistente').on('change', function() {
            var html = ''
            html += '<div class="row pt-1 elemento_designer">'
            html += '<div class="col-8 col-lg-10"><div class="wrapper d-flex align-items-center">'+$(this).find("option:selected" ).text()+'</div></div>'
            html += '<div class="col-4 col-lg-2"><button type="button" data-id="'+$(this).val()+'" data-tipo="azienda" class="btn-rimuovi-anagrafica w-100 btn btn-outline-dark">Rimuovi</button></div></div>'
            $('.selezione_aziende').append(html)
            $('#addAziendaModal').modal('hide')

            checkElementiAziendeLength()

            update_acf_relation('update_field_relation', $(this), $(this).attr('data-id-project'))
        })
    }

    if($('#regolamentoModalLauncher').length) {
        const regolamentoModal = new Modal('#regolamentoModal', {
            keyboard: false,
            backdrop: 'static'
        })
        regolamentoModal.show();
        $('#accetta_regolamento').click(function() {
            jQuery.ajax({
                type: "POST",
                url: ajax_auth_object.ajaxurl,
                data: {
                    'security': $('input[name="security"]').val(),
                    action: 'accetta_regolamento',
                    'languagecode': ajax_auth_object.languagecode
                },
                beforeSend: function() {
                    $('#spinner_wrapper').removeClass('d-none')
                },
                success: function (data) {
                    location.reload()
                }
            });
        })

        // Seleziona il div scrollabile e il bottone
        const scrollableContent = document.getElementById('testo_regolamento');
        const scrollButton = document.getElementById('accetta_regolamento');

        // Aggiungi l'evento di scroll al div
        scrollableContent.addEventListener('scroll', function() {
            // Calcola la distanza scorsa e la distanza totale scrollabile
            const scrollTop = scrollableContent.scrollTop;
            const scrollHeight = scrollableContent.scrollHeight;
            const clientHeight = scrollableContent.clientHeight;
        
            // Controlla se siamo vicini alla fine (es. 90% del contenuto)
            const isNearBottom = scrollTop + clientHeight >= scrollHeight * 0.9;

            // Attiva il bottone solo se siamo vicini alla fine
           if (isNearBottom) {
                scrollButton.disabled = false;
            } else {
                scrollButton.disabled = true;
            }
        });
    }

    function openModalAnagrafiche(event, modalId, tipo) {
        $('.form_aggiunta').addClass('d-none')

        var project_id = $(event.relatedTarget).closest('#form_progetto').find('input[name="project_id"]').val()
        var $form = $( modalId+' .wpcf7-form').eq(0);
        $($form).append('<input type="hidden" name="project_id" value="'+project_id+'" />')
        $( modalId+' #selezione_'+tipo+'_esistente').attr('data-id-project', project_id)
        jQuery.ajax({
            type: "POST",
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'get_'+tipo,
                project_id: project_id,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                if(tipo=='designers')
                    var frase = ajax_auth_object.translations.seleziona_designer_inserito
                else
                    var frase = ajax_auth_object.translations.seleziona_azienda_inserita
   
                $('#selezione_'+tipo+'_esistente')
                    .empty()
                    .append('<option value="">'+frase+'</option>')
                ;
                if(data.data.length>0) {
                    $('.select_esistente').removeClass('d-none')
                    $('.form_aggiunta').addClass('d-none')
                    for (let i = 0; i < data.data.length; i++) { 
                        $('#selezione_'+tipo+'_esistente').append($('<option>', {
                            value: data.data[i].ID,
                            text: data.data[i].post_title
                        }));
                    }
                } else {
                    $('.select_esistente').addClass('d-none')
                    $('.form_aggiunta').removeClass('d-none')
                }

                $('#spinner_wrapper').addClass('d-none')
            }
        });
    }




    $('body').on('click', '.btn-rimuovi-anagrafica', function() {
        
        const id_designer = $(this).data('id')
        const project_id = parseInt($(this).closest('#form_progetto').find('input[name="project_id"]').val())
        const tipo = $(this).data('tipo')

        $.ajax({
            type: 'POST',
            dataType: 'json',
            context: this,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                'action' : 'remove_field_relation', 
                'name' : tipo, 
                'value' : id_designer,
                'project_id': project_id
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function(response) {

                $(this).closest('.elemento_designer').remove()
                if(tipo=='designer')
                    checkElementiDesignerLength()
                if(tipo=='azienda')
                    checkElementiAziendeLength()

                aggiorna_completamento(response, $(this))

                $('#spinner_wrapper').addClass('d-none')
            }
        });  
    })

    if($('.steps_wrapper .step1').hasClass('open')) {
        $('#open_registrati').click(function() {
            $('.form_registrazione').removeClass('d-none')
            $('.form_login').addClass('d-none')
        })
        $('#open_login').click(function() {
            $('.form_registrazione').addClass('d-none')
            $('.form_login').removeClass('d-none')
        })
    }

    $('.wpcf7-form-control[name="PASSWORD"]').attr('type', 'password')
    $('.wpcf7-form .wpcf7-form-control').each(function() {
        if($(this).hasClass('wpcf7-validates-as-required')) {
            var placeholder = $(this).attr('placeholder')
            $(this).attr('placeholder', placeholder+'*')
        }
    })


    $('body').on('click', '.menu-item .material-symbols-outlined', function() {
        $(this).next('.dropdown-menu').toggleClass('d-none');
    });
    if($(window).width()>990) {

        $('body').on('mouseenter', '.dropdown', function(){ 
            $(this).find('.dropdown-menu').removeClass('d-none');
        });
        $('body').on('mouseleave', '.dropdown', function(){ 
            $(this).find('.dropdown-menu').addClass('d-none');
        });

    }


    $('.link-ev-modal').click(function() {
        $(this).next('.modal').appendTo("#wrapperModalLavora");
        var dest = $(this).data('dest');
        const myModal = new Modal(dest)
        myModal.show();
    });

    $('.navbar-toggler').click(function() {
        $(this).toggleClass('collapsed');
        $('#navbarToggler').toggleClass('aperto');
        $('body').toggleClass('noscroll');
    });

    if($(window).width()<990) {
        $('.titolo_sidebar_shop').click(function(e) {
            e.preventDefault();
            $('.sidebar_shop').toggleClass('open');
        })
    }
    
    
    /*
    $('.business_model_canvas_grid .row').each(function(index, el) {
        new Isotope( el, {
            itemSelector: '.wp-block-evidenzio-column',
            percentPosition: true,
            masonry: {
              // use outer width of grid-sizer for columnWidth
              columnWidth: '.wp-block-evidenzio-column'
            }
        })    
    });
    */

    /*
    gsap.utils.toArray(".ev_header").forEach((section) => {
        gsap
        .timeline({
          scrollTrigger: {
            trigger: section,
            start: 'top center',
            //markers: true,
          },
        })
        .from(
          $(section).find('.article_thumbnail'),
          { y: 80, 'opacity':0, duration: 1.5, stagger: .5 }
        );
    });
    */

    $('a.scroll-link, .scroll-link>a').click(function(e) {
        e.preventDefault();
        var link = $(this).attr('href');
        $('html, body').animate({ scrollTop: $('#'+link).offset().top-200}, 800);
    });

    

    //Fancybox.bind('.woocommerce-product-gallery__image a');


    if($(window).width()<990) {
        $('footer .titolo-widget-sidebar').click(function() {
            if($(this).find('.toggler').length) $(this).nextAll('div').slideToggle();
        });
        $('footer .toggler').each(function() {
            $(this).parent('.titolo-widget-sidebar').nextAll().hide();
        });
    }

	$('.variations select').each(function() {
		var opz = $(this).val();
		console.log($(this).val());
		$('a[data-opzione="'+opz+'"]').addClass('selected');
	});

    if($('.wc-block-product-categories').length) {
        $('.wc-block-product-categories > ul > li').each(function(){
            if($(this).find('ul').length) {
                $(this).append('<span class="toggler"></span>');
            }
        });
        $('body').on('click', '.wc-block-product-categories .toggler', function() {
            $(this).prev('ul').toggle();
            $(this).toggleClass('aperto');
        });
        var currentH1 = $('#content h1').text();
        $('.wc-block-product-categories a').each(function(){
            var titolo = $(this).text();
            if(titolo==currentH1) {
                $(this).addClass('active');
                $(this).parents('ul').prevAll('a').addClass('active');
                $(this).parents('ul').show();
                $(this).parents('ul').next('.toggler').addClass('aperto');
            }
        });
    }

    $( 'body' ).on( 'click', '.qtyupdate', function(e) {

        e.preventDefault();

        var item_hash = $( this ).data( 'hash' );
        var item_quantity = $( this ).data( 'qty' );

        if($(this).hasClass('disabled')) return false; 

        $('.loader-spinner').removeClass('hidden');

        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                'action' : 'update_item_from_cart', 
                'cart_item_key' : item_hash, 
                'qty' : item_quantity  
            },
            success: function(data) {
                if ( data && data.fragments ) {
                    $.each( data.fragments, function( key, value ) {
                        $( key ).replaceWith( value );
                    });
                    $( document.body ).trigger( 'wc_fragments_refreshed' );
                }
            }
        });  

    });



    $( 'body' ).on( 'click', '.add_coupon_custom button', function(e) {
        e.preventDefault();
        var data = {
            coupon_code: jQuery(this).prev('input').val(), 
            security: ajax_auth_object.apply_coupon_nonce
        };

        $('.loader-spinner').removeClass('hidden');
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: '/?wc-ajax=apply_coupon',
            data: data,
            complete: function() {
                //$( document.body ).trigger( 'applied_coupon', [ coupon_code ] );
                get_minicart();
            }
        });  

    });



    function get_minicart() {
        var data = {
            'action' : 'get_minicart', 
            coupon_code: jQuery(this).prev('input').val(), 
            security: ajax_auth_object.apply_coupon_nonce
        };

        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_auth_object.ajaxurl,
            data: data,
            success: function(data) {
                if ( data && data.fragments ) {
                    $.each( data.fragments, function( key, value ) {
                        $( key ).replaceWith( value );
                    });
                    $( document.body ).trigger( 'wc_fragments_refreshed' );
                }
            }
        });  

    }

    $('.add_coupon_box .toggler').click(function() {
        $('.add_coupon_custom').toggleClass('hidden');
    }) 

    $('body').on('click', '.close_cart', function() {
        $('#minicart_box').addClass('d-none');
    });

    $('body').on('click', '.menu_cart', function() {
        var count = $(this).find('.cart-contents-count').data('count');
        if(count>0) $('#minicart_box').removeClass('d-none');
    });

    $('body').on( 'added_to_cart', function(){
        $('#minicart_box').removeClass('d-none');
    });


	if($('.varianti_radio').length) {
        $('.varianti_radio a').click(function(e) {
            e.preventDefault();
            var attributo = $(this).attr('data-attributo');
            var opzione = $(this).attr('data-opzione');
            $(this).parent().parent('.row').find('a').removeClass('selected');
            $(this).addClass('selected');
            $('select#'+attributo).val(opzione).change();
            $('.varianti_radio a').each(function(){
                var l = $('select#'+$(this).attr('data-attributo')).find('option[value="'+$(this).attr('data-opzione')+'"]');
                if( l.length==0 ) {
                    $(this).parent('div').addClass('disabled');
                } else {
                    $(this).parent('div').removeClass('disabled');
                }
            });
            $('.single_variation_wrap p.price').hide();
        })    
	}





    $('.titolo_pb').each(function() {
        var ancora = $(this).data('ancora');
        if( !(typeof ancora === 'undefined' || ancora === null) ){
            $(this).on('click', function() {
                if($('#idmanuale_'+ancora).length) 
                    $('html, body').animate({ scrollTop: $('#idmanuale_'+ancora).offset().top}, 800);
                else
                    console.log('#idmanuale_'+ancora+' non trovato!!');
            });
        }
    });

    if($(window).width()<990) {
        $('.mobile-toggler .titolo_pb').click(function() {
            $(this).toggleClass('aperto');
            $(this).parents('.mobile-toggler').toggleClass('aperto');
        });
    }


        // ricerca ajax
        (function ($) {
            $.fn.delayKeyup = function(callback, ms){
                var timer = 0;
                $(this).keyup(function(){                   
                    clearTimeout (timer);
                    timer = setTimeout(callback, ms);
                });
                return $(this);
            };
        })(jQuery);

        for (let ii = 1; ii < 4; ii++) {
            $('.search_form #search-'+ii).delayKeyup(function(){ 
        
                    var string = $('.search_form #search-'+ii).val();
                    if(string.length>3) {
                        var security = $('.search_form #security').val();
                        $.ajax({
                            type: 'POST',
                            dataType: 'json',
                            url: ajax_auth_object.ajaxurl,
                            data: {
                                'action': 'ajaxsearch',
                                'string': string,
                                'security': security,
                                'lang': ajax_auth_object.languagecode
                            },
                            beforeSend: function() {
                                $('.search_results').html('<div class="lds-ripple"><div></div><div></div></div>');
                            },
                            success: function (data) {
                                var html = '<div class="row">';
    
                                $.each(data, function(index, item) {

                                    html += '<article class="mb-2 mb-lg-3 col-12 col-lg-4 product type-product status-publish has-post-thumbnail">';
                                    html += '<div class="wrapper"><div class="top">'+item.thumb+'</div>';
                                    html += '<div class="bottom p-2"><h3 class="entry-title">'+item.post_title+'</h3><p>'+item.post_excerpt+'</p>';
                                    html += '<a href="'+item.url+'" data-quantity="1" class="button product_type_variable add_to_cart_button">Scegli</a></div></div></article>';
                                
                                });

                                html += '</div>';
                                
                                $('.search_results').html(html);
                            }
                        });
                    }
            }, 500);
        }


    $('.radio_visualizzazione').change(function() {
        $('#filter_form').submit()
    })

});


jQuery( function( $ ) {

	// wc_add_to_cart_params is required to continue, ensure the object exists
	if ( typeof wc_add_to_cart_params === 'undefined' )
		return false;
	
	// Ajax add to cart
	$( document ).on( 'click', '.variations_form .single_add_to_cart_button', function(e) {
		
		e.preventDefault();
		
		var $variation_form = $( this ).closest( '.variations_form' );
		var var_id = $variation_form.find( 'input[name=variation_id]' ).val();
		var product_id = $variation_form.find( 'input[name=product_id]' ).val();
		var quantity = $variation_form.find( 'input[name=quantity]' ).val();
		
		//attributes = [];
		$( '.ajaxerrors' ).remove();
		var item = {},
			check = true;
			
			var variations = $variation_form.find( 'select[name^=attribute]' );
			
			/* Updated code to work with radio button - mantish - WC Variations Radio Buttons - 8manos */ 
			if ( !variations.length) {
				variations = $variation_form.find( '[name^=attribute]:checked' );
			}
			
			/* Backup Code for getting input variable */
			if ( !variations.length) {
    			variations = $variation_form.find( 'input[name^=attribute]' );
			}
		
		variations.each( function() {
		
			var $this = $( this ),
				attributeName = $this.attr( 'name' ),
				attributevalue = $this.val(),
				index,
				attributeTaxName;
		
			$this.removeClass( 'error' );
		
			if ( attributevalue.length === 0 ) {
				index = attributeName.lastIndexOf( '_' );
				attributeTaxName = attributeName.substring( index + 1 );
		
				$this
					.addClass( 'required error' )
					.before( '<div class="ajaxerrors"><p>Please select ' + attributeTaxName + '</p></div>' )
		
				check = false;
			} else {
				item[attributeName] = attributevalue;
			}
		
		} );
		
		if ( !check ) {
			return false;
		}
		
		var $thisbutton = $( this );

		if ( $thisbutton.is( '.variations_form .single_add_to_cart_button' ) ) {

			$thisbutton.removeClass( 'added' );
			$thisbutton.addClass( 'loading' );

			var data = {
				action: 'woocommerce_add_to_cart_variable_rc',
			};

			$variation_form.serializeArray().map(function (attr) {
				if (attr.name !== 'add-to-cart') {
				    if (attr.name.endsWith('[]')) {
				        let name = attr.name.substring(0, attr.name.length - 2);
				        if (!(name in data)) {
				            data[name] = [];
				        }
				        data[name].push(attr.value);
				    } else {
				        data[attr.name] = attr.value;
				    }
				}
			});

			// Trigger event
			$( 'body' ).trigger( 'adding_to_cart', [ $thisbutton, data ] );

			// Ajax action
			$.post( wc_add_to_cart_params.ajax_url, data, function( response ) {

				if ( ! response ) {
					return;
				}

				if ( response.error && response.product_url ) {
					window.location = response.product_url;
					return;
				}

				// Redirect to cart option
				if ( wc_add_to_cart_params.cart_redirect_after_add === 'yes' ) {
					window.location = wc_add_to_cart_params.cart_url;
					return;
				}

				// Trigger event so themes can refresh other areas.
				$( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash, $thisbutton ] );

			});

			return false;

		} else {
			
			return true;
		}

	});

});

jQuery(document).ready( function($) { 

    if($('.scrollToTopBtn').length) {
        var scrollToTopBtn = document.querySelector(".scrollToTopBtn");
        var rootElement = document.documentElement;
        function handleScroll() {
        var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
        if (rootElement.scrollTop / scrollTotal > 0.1) {
            scrollToTopBtn.classList.add("showBtn");
        } else {
            scrollToTopBtn.classList.remove("showBtn");
        }
        }
        function scrollToTop() {
        rootElement.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        }
        scrollToTopBtn.addEventListener("click", scrollToTop);
        document.addEventListener("scroll", handleScroll);
    }

    
    $('.btn-step-2').click(function(e) {
        e.preventDefault()

        const projects_ids = $('.riepilogo_progetti .form-check-input:checked').map(function() {
            return $(this).val()
        })
        const ids = projects_ids.get()

        if(!ids.length) {
            alert(ajax_auth_object.translations.seleziona_almeno)
            return false 
        }

        /*
        jQuery.ajax({
            type: "POST",
            context: this,
            url: ajax_auth_object.ajaxurl,
            data: {
                'security': $('input[name="security"]').val(),
                action: 'add_projects_to_cart',
                projects_ids: ids,
                'languagecode': ajax_auth_object.languagecode
            },
            beforeSend: function() {
                $('#spinner_wrapper').removeClass('d-none')
            },
            success: function (data) {
                if(data.success) window.location.href = $(this).data('href')
            }
        });*/
        
        var form = '<form id="to_step_3" method="post" action="'+ajax_auth_object.step_3_link+'" class="d-none"><input type="hidden" name="ids" value="'+ids+'"/></form>'
        $(this).after(form)
        $('#to_step_3').submit()

    })

    /*
    $('.wpcf7-form .country-wrapper select').change(function() {
        manage_provincia_select($(this))
    })
    if($('.wpcf7-form .country-wrapper select').length) {
        manage_provincia_select($('.wpcf7-form .country-wrapper select'))
        if($('.wpcf7-form .provincia-wrapper input[name="DEFAULT_PROVINCIA"]').length && $('.wpcf7-form .provincia-wrapper input[name="DEFAULT_PROVINCIA"]').val()!=='') {

            const default_provincia = $('.wpcf7-form .provincia-wrapper input[name="DEFAULT_PROVINCIA"]').val()
            $('.wpcf7-form .provincia-wrapper select').val($('.wpcf7-form .country-wrapper select').val()+'__'+default_provincia)
        }
    }
    function manage_provincia_select(element) {
        const provincia_wrapper = element.closest('.country-wrapper').next('.provincia-wrapper')
        provincia_wrapper.find('select option').removeClass('d-none')

        if(element.val()=='') {
            provincia_wrapper.addClass('d-none')
        } else {

            const selected_country = element.val()
    
            provincia_wrapper.find('select option').each(function() {
                const opt_val = $(this).val()
                if (opt_val.indexOf(selected_country+'__') !== 0 && opt_val!=='') {
                    $(this).addClass('d-none')
                }
            })    

            var visibili = provincia_wrapper.find('select option:not(.d-none)').length
            if(visibili>1) {
                provincia_wrapper.removeClass('d-none')
            } else {
                provincia_wrapper.addClass('d-none')
            }

        }
    }*/

    $('#aziende_select').change(function() {

        if($(this).val()!=='') {
            jQuery.ajax({
                type: "POST",
                context: this,
                url: ajax_auth_object.ajaxurl,
                data: {
                    'security': $('input[name="security"]').val(),
                    action: 'load_dati_azienda',
                    azienda_id: $(this).val(),
                    'languagecode': ajax_auth_object.languagecode
                },
                beforeSend: function() {
                    $('#spinner_wrapper').removeClass('d-none')
                },
                success: function (result) {
                    if(result.data) {
                        $('.wpcf7-form input[name="RAGSOCIALE"]').val(result.data.fields.ragione_sociale)
                        $('.wpcf7-form input[name="INDIRIZZO"]').val(result.data.fields.indirizzo)
                        $('.wpcf7-form input[name="CITTA"]').val(result.data.fields.citta)
                        $('.wpcf7-form input[name="PROVINCIA"]').val(result.data.fields.provincia)
                        $('.wpcf7-form input[name="CAP"]').val(result.data.fields.cap)
                        $('.wpcf7-form input[name="COUNTRY"]').val(result.data.fields.nazione)
                        $('.wpcf7-form input[name="WEB"]').val(result.data.fields.website)
                        $('.wpcf7-form input[name="NOMEREF"]').val(result.data.fields.nome_referente)
                        $('.wpcf7-form input[name="COGNOMEREF"]').val(result.data.fields.cognome_referente)
                        $('.wpcf7-form input[name="TELREF"]').val(result.data.fields.telefono_referente)
                        $('.wpcf7-form input[name="EMAILREF"]').val(result.data.fields.email_referente)
                    }
                    $('#spinner_wrapper').addClass('d-none')
                }
            });    
        }
    })
})

$('.sidebar_filtri input[type="radio"]').change(function() {
    $('form#filter_form').submit()
})